/**
 * Phone country codes for SMS MFA setup.
 * Shared between SMSMFASetup (settings) and SignupStep6_MFA (signup wizard).
 */

export interface CountryCode {
  code: string;
  label: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  { code: '+1', label: '+1 (US, Canada)' },
  { code: '+44', label: '+44 (UK)' },
  { code: '+353', label: '+353 (Ireland)' },
  { code: '+33', label: '+33 (France)' },
  { code: '+49', label: '+49 (Germany)' },
  { code: '+81', label: '+81 (Japan)' },
  { code: '+86', label: '+86 (China)' },
  { code: '+91', label: '+91 (India)' },
  { code: '+61', label: '+61 (Australia)' },
  { code: '+39', label: '+39 (Italy)' },
  { code: '+34', label: '+34 (Spain)' },
  { code: '+31', label: '+31 (Netherlands)' },
  { code: '+41', label: '+41 (Switzerland)' },
  { code: '+43', label: '+43 (Austria)' },
  { code: '+46', label: '+46 (Sweden)' },
  { code: '+47', label: '+47 (Norway)' },
  { code: '+48', label: '+48 (Poland)' },
  { code: '+358', label: '+358 (Finland)' },
  { code: '+30', label: '+30 (Greece)' },
  { code: '+90', label: '+90 (Turkey)' },
  { code: '+55', label: '+55 (Brazil)' },
  { code: '+52', label: '+52 (Mexico)' },
  { code: '+64', label: '+64 (New Zealand)' },
  { code: '+65', label: '+65 (Singapore)' },
];
